namespace Areas.Budget.UnLinked {
    "use strict";


    export function linkSelected() {

        const unlinkedGrid = $("#BudgetUnLinkedGrid").dxDataGrid("instance");
        const rowsSelected = unlinkedGrid.getSelectedRowsData();
        if (rowsSelected[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {

            let accountId = unlinkedGrid.option("AccountId");
            let subCode = rowsSelected[0].ucopSubCodeLk;
            let budgetId = unlinkedGrid.option("BudgetId");
            const parameters = { accountId: accountId, sub: subCode, budgetId: budgetId };
            const budgetAccountCategoryLinkDialog =
                new Areas.Dialogs.BudgetAccountCategory.BudgetAccountCategoryLinkDialog(linkDialogClosing(), parameters);
        }
    }

    //select Link Category
    function linkDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const unlinkedGrid = $("#BudgetUnLinkedGrid").dxDataGrid("instance");
            const glDataIds = unlinkedGrid.getSelectedRowKeys().join(',');


            //for each selected record create BudgetItemLink records
            let newBudgetAccountCategoryId: number = 0;
            newBudgetAccountCategoryId = data.budgetAccountCategoryId;

            let url = `/Budget/UnLinked/AddLinkItems/${glDataIds}/${newBudgetAccountCategoryId}`;


            const method = "POST";

            sendRequest(url,
                "",
                method,
                (data) => {
                    Areas.reloadPage();
                });

        }
    }

    export function createAutoLinkForSelected() {
        const unlinkedGrid = $("#BudgetUnLinkedGrid").dxDataGrid("instance");
        const rowsSelected = unlinkedGrid.getSelectedRowsData();
        if (rowsSelected[0] == null) {
            DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
        } else {
            if (rowsSelected.length > 1) {
                DevExpress.ui.notify("Select 1 record to link all with the same Purchase Order!", "warning", 2000);
            } else {
                let accountId = unlinkedGrid.option("AccountId");
                let subCode = rowsSelected[0].ucopSubCodeLk;
                let budgetId = unlinkedGrid.option("BudgetId");
                const parameters = { accountId: accountId, sub: subCode, budgetId: budgetId };
                const budgetAccountCategoryLinkDialog =
                    new Areas.Dialogs.BudgetAccountCategory.BudgetAccountCategoryLinkDialog(autolinkDialogClosing(), parameters);
            }
        }
    }

    //select Link Category
    function autolinkDialogClosing() {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;

            const unlinkedGrid = $("#BudgetUnLinkedGrid").dxDataGrid("instance");
            const rowData = unlinkedGrid.getSelectedRowsData();
           
            let poNumber = rowData[0].glReference;
            let fauobject = rowData[0].fauObject;
            let faudesc = rowData[0].fauDescription.replaceAll('/', '-');
            

            //for each selected record create BudgetItemLink records
            let newBudgetAccountCategoryId: number = 0;
            newBudgetAccountCategoryId = data.budgetAccountCategoryId;

            let url = `/Budget/UnLinked/AddAutoLink/${newBudgetAccountCategoryId}/${poNumber}/${fauobject}/${faudesc}`;


            const method = "POST";

            sendRequest(url,
                "",
                method,
                (data) => {
                    Areas.reloadPage();
                });

        }
    }



}
